import { useTheme } from "@emotion/react";
import { MdClose, MdOutlinePictureAsPdf, MdOutlineUploadFile } from "react-icons/md";

import { NoteAttachmentEntry } from "./supportTicketNoteAttachmentTypes";

type Props = {
  attachments: NoteAttachmentEntry[];
  onRemove: (index: number) => void;
};

export function SupportTicketNoteAttachmentList({ attachments, onRemove }: Props) {
  const theme = useTheme();

  if (attachments.length === 0) return null;

  return (
    <div css={{ display: "flex", flexWrap: "wrap", gap: "0.5rem" }}>
      {attachments.map((attachment, index) => {
        const isImage = attachment.fileType.startsWith("image/");
        const isPdf = attachment.fileType === "application/pdf";
        return (
          <div
            key={`${attachment.fileName}-${index}`}
            css={{
              display: "inline-flex",
              alignItems: "center",
              gap: "0.35rem",
              maxWidth: "100%",
              padding: "0.35rem 0.5rem 0.35rem 0.65rem",
              borderRadius: theme.smallBorderRadius,
              border: `1px solid ${theme.colors.border}`,
              background: theme.colors.primaryLight,
              fontSize: "13px",
              color: theme.colors.primary,
            }}
          >
            {isImage ? (
              <MdOutlineUploadFile size={16} />
            ) : isPdf ? (
              <MdOutlinePictureAsPdf size={16} />
            ) : (
              <MdOutlineUploadFile size={16} />
            )}
            <span
              css={{
                overflow: "hidden",
                textOverflow: "ellipsis",
                whiteSpace: "nowrap",
                maxWidth: "16rem",
              }}
              title={attachment.fileName}
            >
              {attachment.fileName}
            </span>
            <button
              type="button"
              aria-label={`Usuń ${attachment.fileName}`}
              onClick={() => onRemove(index)}
              css={{
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
                border: "none",
                background: "transparent",
                color: theme.colors.primary,
                cursor: "pointer",
                padding: 0,
              }}
            >
              <MdClose size={16} />
            </button>
          </div>
        );
      })}
    </div>
  );
}
